import { createContext, useContext } from 'react';
import { TenantContextProps } from './Tenant.types';

export const TenantContext = createContext<TenantContextProps>({
  loading: false,
  tenantCode: undefined,
  tenant: undefined,
  error: undefined,
  actions: {
    getTenant: async () => {},
    setTenant: async () => {},
    updateFeature: async () => {}
  }
});

export const useTenantContext = () => useContext<TenantContextProps>(TenantContext);
